import { render, staticRenderFns } from "./CreateLiquidation.vue?vue&type=template&id=0139ed6a"
import script from "./CreateLiquidation.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation.vue?vue&type=script&lang=js"
import style0 from "./CreateLiquidation.vue?vue&type=style&index=0&id=0139ed6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports